/**
 * 日志相关类型定义
 */

// 操作类型枚举
export enum LogActionType {
  QUERY = 'QUERY',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE', 
  DELETE = 'DELETE',
  BATCH_DELETE = 'BATCH_DELETE',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  EXPORT = 'EXPORT',
  IMPORT = 'IMPORT',
}

// 操作结果枚举
export enum LogResult {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

// 日志级别枚举
export enum LogLevel {
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
  DEBUG = 'DEBUG',
}

// 日志记录接口
export interface LogRecord {
  id?: number;
  userId: number;
  userName: string;
  userNickname?: string;
  module: string; // 模块名称，如 'news', 'institution', 'showcase'
  action: LogActionType; // 操作类型
  targetType: string; // 目标类型，如 'News', 'Institution'
  targetId?: number; // 目标ID
  targetTitle?: string; // 目标标题或名称
  description: string; // 操作描述
  requestUrl?: string; // 请求URL
  requestMethod?: string; // 请求方法
  requestParams?: string; // 请求参数（JSON字符串）
  responseData?: string; // 响应数据（JSON字符串）
  beforeData?: string; // 修改前的数据（JSON字符串）
  afterData?: string; // 修改后的数据（JSON字符串）
  ipAddress?: string; // IP地址
  userAgent?: string; // 用户代理
  result: LogResult; // 操作结果
  level: LogLevel; // 日志级别
  errorMessage?: string; // 错误信息
  executionTime?: number; // 执行时间（毫秒）
  createTime?: string; // 创建时间
}

// 日志查询参数
export interface LogQueryParams {
  current?: number;
  size?: number;
  keyword?: string;
  userId?: number;
  userName?: string;
  module?: string;
  action?: LogActionType;
  targetType?: string;
  result?: LogResult;
  level?: LogLevel;
  startTime?: string;
  endTime?: string;
  ipAddress?: string;
  orderBy?: string; // 排序字段
  orderDirection?: string; // 排序方向：'asc' | 'desc'
}

// 日志统计信息
export interface LogStatistics {
  totalCount: number;
  todayCount: number;
  successCount: number;
  failedCount: number;
  errorCount: number;
  moduleStats: Array<{
    module: string;
    count: number;
  }>;
  actionStats: Array<{
    action: LogActionType;
    count: number;
  }>;
  hourlyStats: Array<{
    hour: number;
    count: number;
  }>;
}

// 日志详情
export interface LogDetail extends LogRecord {
  beforeData?: string; // 修改前的数据
  afterData?: string; // 修改后的数据
  changes?: Array<{
    field: string;
    oldValue: any;
    newValue: any;
  }>;
}

export default LogRecord;
